// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk-" + {"85":"exceljs","211":"jszip"}[chunkId] + ".js";
};